import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";

export default function AnimatedNumber({ value, prefix = "", suffix = "" }) {
  const elementRef = useRef(null);
  const isInView = useInView(elementRef, { once: true, amount: 0.6 });
  const prefersReducedMotion = useReducedMotion();
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    if (prefersReducedMotion) {
      setDisplayValue(value);
      return;
    }

    const controls = animate(0, value, {
      type: "spring",
      stiffness: 75,
      damping: 25,
      onUpdate: setDisplayValue,
    });
    return () => controls.stop();
  }, [isInView, prefersReducedMotion, value]);

  return (
    <span ref={elementRef} className="tabular-nums">
      <span aria-hidden="true">{prefix}{Math.round(displayValue)}{suffix}</span>
      <span className="sr-only">{prefix}{value}{suffix}</span>
    </span>
  );
}
